import React, { Ref, forwardRef } from 'react';
import styled from 'styled-components';
// @ts-ignore
import DOMPurify from 'dompurify';
import useScrollPosition from '../../../../hooks/useScrollPosition';

interface BannerProps {
    text: string | undefined;
    show: boolean;
}

const Banner = forwardRef<HTMLDivElement, BannerProps>(({ text, show }, ref) => {
    const scrollPosition = useScrollPosition();

    return (
        <StyledBanner className={`importantBanner ${show ? 'show' : ''} ${scrollPosition > 64 ? 'scrolled' : ''}`} ref={ref}>
            { text && (
                <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }} />
            )}
        </StyledBanner>
    );
});

const StyledBanner = styled.div`
    display: flex;
    top: 52px;
    z-index: 10;
    width: 100%;
    background-color: var(--ui_banner_bg);
    color: var(--ui_banner_color);
    font-size: 14px;
    line-height: 20px;
    padding: 8px 16px;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-bottom: var(--layouts_nav_border);
    box-shadow: 0 1px 4px rgb(0 0 0 / 8%);

    height: 0;
    visibility: hidden;

    &.show {
        height: unset;
        visibility: visible;
    }
`;

export default Banner;
